export const ERR_BAD_REQUEST = 400;
